/**
 * Generate the connector configuration for this RecordDef
  * 
 * All plain section fields go to the main table
 * Each fields in a table section go to a table specific for that section,
 * related to the main table by its UUID.
 * 
 * @created: MAZito - 2-Abr-2021
 */
import { cloned, toVarName, slugify } from '@/helpers'
import { RecordDef, is } from '@/models'
import { mapAllSections } from './section-mappers'
import { databaseName } from './db-schema'


export function buildConfigs(recordDef, settings) {

  let mappers = mapAllSections(recordDef.meta)
  
  let remapped = [mappers.plain].concat(mappers.tables);

  const _OPTIONS = {
    'plain': plainOptions,
    'table': tableOptions
  }

  const _CMDS = {
    'plain': plainCommands,
    'table': tableCommands
  }

  let configs = remapped.map((tb) => {

    let tbname = slugify(recordDef.title);
    let type = (tb.type && tb.type==='table') ? 'table' : 'plain';
    const secname = (tb.type && tb.type==='table') ? '_'+tb.name : '';

    // Plugin props

    let plugin = {
      "master_id": recordDef.master_id,
      "alias": tbname + secname,
      "state": "AP",
      "start_datetime": "2020-01-01 00:00:00",
      "database_connect": settings.database.url
                          +"/"+databaseName(recordDef.account_id),
      "cols": []
    }

    plugin = _OPTIONS[type](plugin, tb);

    // All plugin columns

    let record_cols = [
      { "key": "record.uuid", "name": "uid", "type": "text", "default": ""},
      { "key": "record.record_def_id", "name": "r_def_id", "type": "integer"},
      { "key": "record.title", "name":"r_title", "type": "text"},
      { "key": "record.created_utc", "name":"r_created_utc", "type": "datetime", "extra": {"format": "%Y-%m-%d %H:%M:%S"}},
    ] 

    if (type === 'table') record_cols.push(
      { "key": "table.row_index", "name": "row_index", "type": "int", "default": 0}
    );

    let form_cols = tb.cols.map((col) => {
      let cr = {
        key: col.key,
        name: col.name,
        type: col.type,
        default: col.default
      }
      if (col.extra) cr.extra = col.extra;
      return cr;
    })

    plugin.cols = record_cols.concat(form_cols);

    // Plugin SQL commands

    plugin = _CMDS[type](plugin, tb, tbname)
    
    return plugin;
  })

  return configs; // un array de download records
}


function plainOptions(plugin, tb) {
  plugin.plugin = "output_record_simple_database";
  return plugin;
}

function tableOptions(plugin, tb) {
  plugin.plugin = "output_record_list_database";
  plugin.iter_table = tb.key; 
  return plugin;
}

function plainCommands(plugin, tb, tbname) {
  plugin.conditional = true;
  plugin.if_cmd = ifCmd(tbname);
  plugin.then_cmd = updateCmd(tbname, plugin.cols);
  plugin.else_cmd = insertCmd(tbname, plugin.cols);
  return plugin;
}

function tableCommands(plugin, tb, tbname) {
  tbname = tbname+'_'+tb.name;
  plugin.conditional = true;
  plugin.if_cmd = ifCmd(tbname, /*hasRowIndex=*/true);
  plugin.then_cmd = updateCmd(tbname, plugin.cols, /*hasRowIndex=*/true);
  plugin.else_cmd = insertCmd(tbname, plugin.cols);
  return plugin;
}

function ifCmd(tbname, hasRowIndex) {
  const AND_ROW_INDEX = hasRowIndex ? 'AND row_index={row_index}' : '';
  return (`SELECT COUNT(*) FROM ${tbname} WHERE uid={uid} ${AND_ROW_INDEX}`)
}

function insertCmd(tbname, cols) {
  let columns = cols.map((t) => `${t.name}`).join(',')
  let values = cols.map((t) => `{${t.name}}`).join(',');
  return (`INSERT INTO ${tbname} (${columns}) VALUES(${values})`);
}

function updateCmd(tbname, cols, hasRowIndex) {
  let values = cols.map((t) => `${t.name}={${t.name}}`).join(',')
  const AND_ROW_INDEX = hasRowIndex ? 'AND row_index={row_index}' : '';
  return (`UPDATE ${tbname} SET ${values} WHERE uid={uid} ${AND_ROW_INDEX}`);
}

function deleteCmd(tbname, cols) {
  return (`DELETE FROM ${tbname} WHERE uid={uid}`);
}
